<template>
    <div v-show="isSuccessModalVisible" class="mm_body">
        <div class="modal-mask" @click="close">
            <div class="modal-container" @click.stop>
                <!-- Modal body -->
                <div class="modal-body" id="modalContent">
                    <button type="button" class="close" data-dismiss="modal" @click="close">&times;</button>
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <div class="text-center">
                                <p>You're All Set!</p>    
                                <div><img :src="mmSiteUrl + 'wp-content/uploads/2021/02/success.svg'"/></div>
                                <p>If that email matches an account you will see a <br/>password reset link shortly.</p>
                                <p class="call_hint">If you have any questions, feel free to call us at</p>
                                <p><a href="tel:(888) 800-9250" class="mm_dial">(888) 800-9250</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.mm_body { color: #707070; }
p { margin: 10px 0; font-size: 18px;}
.close { color: #FFF; }
.btn {
    border-radius: 18px;
    border: none;
    font-size: 22px !important;
    font-weight: bold;
    font-style: normal;
}
.btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
}
.btn-white:hover { color: #000 !important; text-decoration: underline; }
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}
.modal-container {
    width: 680px;
    margin: 210px auto 0;
    padding: 0px;
    background-color: #7CC588;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    text-align: left;
    border: none;
    color: #FFF;
}
.panel {
    border-color: #7CC588;
    background-color: #7CC588;
    color: #FFF;
}
.modal-body {
    margin: 0px;
    padding: 10px;
}
@media(max-width:560px) {
  .modal-container {
    width: 96%;
    padding: 20px 20px;
  }
  .modal-body {
      margin: 0px;
      padding: 0px;
      height: 100%;
  }
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
  border: 0px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.modal-footer {
  border-top: none;
}
.inner-page {
    font-family: "proxima-nova" , Arial, verdana !important;
    font-size: 28px;
    font-weight: normal;
}
.btn-white:hover {
    color: #000 !important;    
}
.btn-white {
    background-color: #efefef !important;
}
#modalContent {
    color: #707070;
}
.call_hint { font-size: 14px; margin: 20px 0; }
.mm_dial, .mm_dial:hover { text-decoration: none; color: #FFF!important; }
</style>
<script>
import axios from 'axios';
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['mmSiteUrl','isSuccessModalVisible'],
    data: function () {
        return {
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/mm_success_modal.vue